export default new (class RolesHelper {
  hasRole = (roleToSeek, roles) => roles.includes(roleToSeek);
  hasAtLeastOneRole = (rolesToSeek, roles) => {
    for (const role of rolesToSeek) if (this.hasRole(role, roles)) return true;
    return false;
  };
})();
